import { Link } from 'react-router-dom';
import { faChevronsRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Job } from '@core/generated/gql-types';

interface HeaderSectionProps {
  job: Job;
  onClose: () => void;
}

const HeaderSection = ({ job, onClose }: HeaderSectionProps) => {
  return (
    <div className="sticky top-0 flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4">
      <button
        type="button"
        className="cursor-pointer rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
        onClick={onClose}
      >
        <FontAwesomeIcon icon={faChevronsRight} className="ml-1 h-3 w-3" />
      </button>
      <Link
        to={`/jobs/${job.id}`}
        className="flex cursor-pointer items-center text-sm font-medium text-blue-600 hover:text-blue-700"
      >
        See job details
      </Link>
    </div>
  );
};

export default HeaderSection;
